import { render, staticRenderFns } from "./FormPassword.vue?vue&type=template&id=167164c2&scoped=true&"
import script from "./FormPassword.vue?vue&type=script&lang=js&"
export * from "./FormPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167164c2",
  null
  
)

export default component.exports